import PropTypes from "prop-types"
import React from "react"
import SmartLink from "../../../layout/SmartLink/SmartLink"
import { BodyText, InlineText } from "../../../Typography/Typography"
import { BROWSE_SEARCH_PATH } from "../../../../utils/paths"
import { additionalLineHeight } from "./styles.module.scss"

const getMoyoLink = (careServiceType, locationName) =>
  `${BROWSE_SEARCH_PATH}?care_type=care_home&location=${locationName}&care_provided[]=${careServiceType}`

const careServiceTypeClickEvent = (careServiceType, linkPosition) => ({
  name: "SEO - Filtered Directory - Care Type Filter Clicked",
  properties: {
    "Care Specialism": careServiceType,
    "Link Position": linkPosition + 1,
  },
})

const countText = (count) => (count === 1 ? "1 home" : `${count} homes`)

const TownServiceLink = ({ town, linkPosition, careServiceType }) => (
  <SmartLink
    className={additionalLineHeight}
    to={getMoyoLink(careServiceType, town.name)}
    clickEvent={careServiceTypeClickEvent(careServiceType, linkPosition)}
  >
    <InlineText semibold brand>
      {town.name}
    </InlineText>
    <InlineText brand> ({countText(town.ratedPositiveCount)})</InlineText>
  </SmartLink>
)

const FeaturedServiceTowns = ({ featuredTowns, careServiceType }) => (
  <>
    <BodyText semibold>Top towns for {careServiceType} care</BodyText>
    <ul>
      {featuredTowns.map((town, linkPosition) => (
        <li key={`${town.name}-${careServiceType}`}>
          <TownServiceLink
            town={town}
            careServiceType={careServiceType}
            linkPosition={linkPosition}
          />
        </li>
      ))}
    </ul>
  </>
)

TownServiceLink.propTypes = {
  town: PropTypes.shape({
    name: PropTypes.string,
    ratedPositiveCount: PropTypes.number,
  }).isRequired,
  linkPosition: PropTypes.number.isRequired,
  careServiceType: PropTypes.string.isRequired,
}

FeaturedServiceTowns.propTypes = {
  featuredTowns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      ratedPositiveCount: PropTypes.number,
    }),
  ),
  careServiceType: PropTypes.string.isRequired,
}

FeaturedServiceTowns.defaultProps = {
  featuredTowns: undefined,
}

export default FeaturedServiceTowns
